import { apiServices } from "../../../../core/utilities/ApiServices";
import InfoVideo from "../../domain/entities/InfoVideo";

export interface AdminDataSource {
	getVideos(): Promise<InfoVideo[]>;
}

export class AdminDataSourceImpl implements AdminDataSource {
	async getVideos(): Promise<InfoVideo[]> {
		const response = await apiServices.get(`/admin/videos`);
		if (response.status === 200) {
			return response.data;
		} else {
			throw new Error();
		}
	}
}
